// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_2idiYNQf","menu":"_3bANsFZD","logo":"_3FXetM7w","content":"_3wGJMBHE","desktop-container":"wWqgS7m2","mobile-menu-container":"_10TTMq2v","session-container":"_1ilgsx0s","left-container":"_1u4xSEAZ","workout-link":"_1vHwoUby","profile":"_1EvKA93R","userName":"_2jibn5SW","label":"_25BxfPm6","profileImage":"_2WE75Dk4","icon":"_2r4KsVXE","burger":"mlsxWIqu","button":"_1vKoXgpi","is-open":"_3T3pHpTf","mobileMenu":"_2w18yxgm","mobile-menu-content":"_2wbBiRtF"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/SessionMenu/SessionMenu.styl
// module id = 377
// module chunks = 0